import { VariantProps, cva } from 'class-variance-authority';

export const root = cva([]);

export const item = cva([]);

export const itemHeader = cva('py-2', {
  variants: {
    border: {
      true: ['border-b', 'border-neutral-500', 'data-[state=open]:border-b-0'],
      false: [],
    },
  },
  defaultVariants: {
    border: true,
  },
});

export const itemContent = cva('pb-2', {
  variants: {
    border: {
      true: ['data-[state=open]:border-b', 'border-neutral-500'],
      false: [],
    },
  },
  defaultVariants: {
    border: true,
  },
});

export type ItemHeaderProps = VariantProps<typeof itemHeader>;
